<template>
  <div class="tw-container tw-mx-auto tw-pt-8">
    <div
      v-if="me.role === $roles.ADMIN || me.role === $roles.CONSULTANT"
      class="tw-mb-8"
    >
      <i-button
        @click="isAddQuestionnaireDialogOpen = true"
      >
        <icon-plus />
        {{ $t('quest.add_questionnaire') }}
      </i-button>
      <AddQuestionnaireDialog
        :is-open="isAddQuestionnaireDialogOpen"
        @close="isAddQuestionnaireDialogOpen = false"
      />
    </div>

    <div class="tw-mb-8">
      <ForeignersQuestionnairesList />
    </div>
  </div>
</template>

<script>
import AddQuestionnaireDialog from '@/components/Dialogs/AddQuestionnaireDialog.vue';
import { mapState } from 'vuex';
import ForeignersQuestionnairesList from '@/components/Foreigners/Questionnaires/ForeignersQuestionnairesList.vue';

export default {
  name: 'ForeignersQuestionnaires',
  components: {
    ForeignersQuestionnairesList,
    AddQuestionnaireDialog,
  },

  data() {
    return {
      isAddQuestionnaireDialogOpen: false,
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.v2.shared.profile.me,
    }),
  },
};
</script>
